import { render } from "./DoubleNav.vue?vue&type=template&id=39dfbb5f"
import script from "./DoubleNav.vue?vue&type=script&lang=js"
export * from "./DoubleNav.vue?vue&type=script&lang=js"

import "./DoubleNav.vue?vue&type=style&index=0&id=39dfbb5f&lang=css"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__